module.exports = __webpack_public_path__ + "img/processing.4bf92863.svg";